module.exports = __webpack_public_path__ + "img/light1.390fef49.png";